import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';


@Component({
  selector: 'testbed-utc-clock',
  template: `
  <div class="d-flex flex-row small text-muted font-italic text-nowrap">
    <div class="card d-flex flex-row p-sm-1 mr-2">
        <span class="font-weight-bold pr-1">Time Zone</span>
        <span>{{timeZone}} ({{now|date:'zzz'}})</span>
    </div>
    <div class="card d-flex flex-row p-sm-1">
        <span class="font-weight-bold pr-1">Universal Time</span>
        <span>{{now|date:'yyyy-MM-dd HH:mm:ss UTC':'UTC'}}</span>
    </div>
  </div>`
})
export class UtcClockComponent implements OnInit, OnDestroy {

    now: Date = new Date()

    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

    updateTimeSubscription : Subscription

    ngOnInit(): void {
        this.updateTimeSubscription = timer(0,1000).subscribe(_=>this.now = new Date())
    }

    ngOnDestroy(): void {
        this.updateTimeSubscription?.unsubscribe()
    }
}